import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import { Guid } from "guid-typescript";
import store from "../../store";
import service from "../../services/api.service";
import { plainToClass } from "class-transformer";
import { ClockWorkEntryModel } from "../../store/models/clockWork/clockWorkEntry";
import { ClockWorkEntryOperation } from "../models/clockWork/payload";
import { getTenantId } from "@/store/helper";
import { ProjectTaskComboModel } from "../models/project/projectTaskCombo";
import { TimeReportEntryModel } from "../models/clockWork/timeReportEntry";
import { ITimeReportDTO } from "../models/clockWork/timeReport";
import { ProjectReportEntryModel } from "../models/clockWork/projectReportEntry";
import { CumulativeProjectReportEntryModel } from "../models/clockWork/cumulativeProjectReportEntry";
import { IProjectReportDTO } from "../models/clockWork/projectReport";
import { formatDistanceToNow, isToday, isYesterday } from "date-fns";
import { checkGaps } from "@/types/gapChecker";
import { IClockWorkMiniResponse } from "../models/clockWork/response/clockWorkMiniResponse";
import { ClockWorkProjectSummaryModel } from "../models/clockWork/clockWorkDayProjectSummary";
import { ClockWorkRunningEntryModel } from "../models/clockWork/clockWorkRunningEntry";
import { CumulativeTimeReportEntryModel } from "../models/clockWork/cumulativeTimeReportEntry";
import { Vue } from "vue-property-decorator";
let ClockWorksModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30;
    let ClockWorksModule = class ClockWorksModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.entries = [];
            this.weekEntries = [];
            this.cwMiniEntry = null;
            this.longRunningEntry = false;
            this.isClockWorkSetWeeklyMail = false;
            this.defaultProjectAndTask = null;
            this.clockWorkSettingRequest = null;
            this.clockWorkNullEntries = [];
            this.projectDaySummaries = [];
            this.projectWeekSummaries = [];
            this.cumulativeTimeReportClockWorkEntries = [];
            this.apiNode = "clockwork";
            this.liveTime = 0;
            this.timeReportClockWorkEntries = [];
            this.validProject = [];
            this.projectReportEntries = [];
            this.cumulativeProjectReportEntries = [];
            this.validProjectReportProjects = [];
            this.projectReportMembers = [];
            this.projectReportProjectDisplayString = "";
            this.projectReportTotalTime = 0;
            this.filteredEntries = [];
            this.searchedEntries = [];
            this.totalCount = 0;
            this.isWFO = false;
            this.totalTime = 0;
        }
        //cwMiniLoaded: boolean = false;
        async GetEntries(entryDate) {
            var url = `${getTenantId()}/${this.apiNode}/${entryDate}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetEntries(plainToClass(ClockWorkEntryModel, data.clockWorkEntries));
                this.SetDefaultProject(plainToClass(ProjectTaskComboModel, data.defaultProject));
                this.SetClockWorkWeekly(data.isClockWorkSetWeeklyMail);
                this.SetIsWFO(data.isWFO);
                return data;
            }
        }
        async GetClockWorkRunningEntries() {
            var url = `${getTenantId()}/${this.apiNode}/getRunningEntries`;
            let { data } = await service.get(url);
            if (data) {
                this.SetClockWorkRunningEntries(plainToClass(ClockWorkRunningEntryModel, data.clockWorkRunningEntries));
                return data;
            }
        }
        async AddEntry(clockWorkEntry) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let operation = new ClockWorkEntryOperation();
            operation.type = "add";
            operation.entryPayLoad = clockWorkEntry;
            let { data } = await service.post(url, operation);
            if (data) {
                this.AppendEntries(plainToClass(ClockWorkEntryModel, data.clockWorkEntries));
                return data;
            }
        }
        async RestartEntry(starterEntry) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let operation = new ClockWorkEntryOperation();
            operation.type = "restart";
            operation.entryPayLoad = starterEntry;
            let { data } = await service.post(url, operation);
            if (data) {
                this.AppendEntries(plainToClass(ClockWorkEntryModel, data.clockWorkEntries));
                return data;
            }
        }
        async CrossoverEntry(crossoverEntry) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let operation = new ClockWorkEntryOperation();
            operation.type = "crossover";
            operation.entryPayLoad = crossoverEntry;
            let { data } = await service.post(url, operation);
            if (data) {
                ClockWorkModule.RemoveRunningEntry(crossoverEntry.id);
                this.AppendEntries(plainToClass(ClockWorkEntryModel, data.clockWorkEntries));
                return data;
            }
        }
        async UpdateEntry(activeEntry) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let operation = new ClockWorkEntryOperation();
            operation.type = "update";
            operation.entryPayLoad = activeEntry;
            let { data } = await service.post(url, operation);
            if (data) {
                this.AppendEntries(plainToClass(ClockWorkEntryModel, data.clockWorkEntries));
                return data;
            }
        }
        async EndEntry(activeEntry) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let operation = new ClockWorkEntryOperation();
            operation.type = "end";
            operation.entryPayLoad = activeEntry;
            let { data } = await service.post(url, operation);
            if (data) {
                this.AppendEntries(plainToClass(ClockWorkEntryModel, data.clockWorkEntries));
                return data;
            }
        }
        async BreakEntry(clockWorkEntry) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let operation = new ClockWorkEntryOperation();
            operation.type = "break";
            operation.entryPayLoad = clockWorkEntry;
            let { data } = await service.post(url, operation);
            if (data) {
                this.AppendEntries(plainToClass(ClockWorkEntryModel, data.clockWorkEntries));
                return data;
            }
        }
        async DeleteEntries(entries) {
            var url = `${getTenantId()}/${this.apiNode}/entries`;
            let { data } = await service.post(url, entries);
            if (data) {
                this.RemoveEntries(entries);
                return data;
            }
        }
        async AssignEntries(payload) {
            var url = `${getTenantId()}/${this.apiNode}/assign-entries?taskId=${payload.taskId}`;
            let { data } = await service.post(url, payload.entries);
            if (data) {
                this.SetAssignEntries(plainToClass(ClockWorkEntryModel, data.clockWorkEntries));
                return data;
            }
        }
        SetAssignEntries(entries) {
            var that = this;
            entries.forEach((entry) => {
                const existingEntry = that.entries.find((x) => x.id == entry.id);
                if (existingEntry) {
                    Object.keys(entry).forEach((key) => {
                        Vue.set(existingEntry, key, entry[key]);
                    });
                }
            });
            checkGaps(that.entries);
        }
        async AdjustEntry(payload) {
            var url = `${getTenantId()}/${this.apiNode}/adjust?entryId=${payload.entryId}&newStartTime=${payload.newStartTime}&newEndTime=${payload.newEndTime}`;
            let { data } = await service.post(url);
            if (data) {
                if (payload.shouldAppendEntries)
                    this.AppendEntries(plainToClass(ClockWorkEntryModel, data.clockWorkEntries));
                return data;
            }
        }
        async AdjustMultipleEntries(payload) {
            var url = `${getTenantId()}/${this.apiNode}/adjustMultipleEntries`;
            let { data } = await service.post(url, payload);
            if (data) {
                return data;
            }
        }
        async SplitEntry(payload) {
            var url = `${getTenantId()}/${this.apiNode}/splitEntry?entryId=${payload.entryId}&splitTime=${payload.splitTime}`;
            let { data } = await service.post(url);
            if (data) {
                this.AppendEntries(plainToClass(ClockWorkEntryModel, data.clockWorkEntries));
                return data;
            }
        }
        async UpFill(activeEntry) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let operation = new ClockWorkEntryOperation();
            operation.type = "upfill";
            operation.entryPayLoad = activeEntry;
            let { data } = await service.post(url, operation);
            if (data) {
                this.AppendEntries(plainToClass(ClockWorkEntryModel, data.clockWorkEntries));
                return data;
            }
        }
        async DownFill(activeEntry) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let operation = new ClockWorkEntryOperation();
            operation.type = "downfill";
            operation.entryPayLoad = activeEntry;
            let { data } = await service.post(url, operation);
            if (data) {
                this.AppendEntries(plainToClass(ClockWorkEntryModel, data.clockWorkEntries));
                return data;
            }
        }
        async UpdateWorkStatus(payload) {
            var url = `${getTenantId()}/${this.apiNode}/updateWorkStatus?isWFO=${payload.isWFO}`;
            let { data } = await service.post(url, payload.entries);
            if (data) {
                this.AppendEntries(plainToClass(ClockWorkEntryModel, data.clockWorkEntries));
                return data;
            }
        }
        async GetProjectsInGivenTimePeriod(timereport) {
            var url = `${getTenantId()}/${this.apiNode}/get-projects`;
            let { data } = await service.post(url, timereport);
            if (data) {
                this.SetProjectsInGivenTimePeriod(data);
                return data;
            }
        }
        async GetUserTimeReport(timereport) {
            var url = `${getTenantId()}/${this.apiNode}/timereport`;
            let { data } = await service.post(url, timereport);
            if (data) {
                this.SetUserTimeReport(plainToClass(TimeReportEntryModel, data.timeReportClockWorkEntries));
                this.setCumulativeTimeReport(plainToClass(CumulativeTimeReportEntryModel, data.cumulativeTimeReportClockWorkEntries));
                this.ToalTime(data.totalTime);
                return data;
            }
        }
        async setCumulativeTimeReport(timeReportClockWorkEntries) {
            this.cumulativeTimeReportClockWorkEntries = timeReportClockWorkEntries;
        }
        async ToalTime(totalTime) {
            this.totalTime = totalTime;
        }
        // Excel Export
        async GetUserTimeReportAsExcel(timereport) {
            var url = `${getTenantId()}/${this.apiNode}/Excel/timereport`;
            let { data } = await service.post(url, timereport, { responseType: "blob" });
            return data;
        }
        async GetProjectsForProjectReport() {
            var url = `${getTenantId()}/${this.apiNode}/project-report-projects`;
            let { data } = await service.post(url);
            if (data) {
                this.SetProjectsForProjectReport(data);
                return data;
            }
        }
        async GetProjectMembersForReport(projectId) {
            var url = `${getTenantId()}/${this.apiNode}/project-report-members?projectId=${projectId}`;
            let { data } = await service.post(url);
            if (data) {
                this.SetProjectReportMembers(data);
                return data;
            }
        }
        async GetProjectReport(projectReport) {
            var url = `${getTenantId()}/${this.apiNode}/projectreport`;
            let { data } = await service.post(url, projectReport);
            if (data) {
                this.SetProjectReport(plainToClass(ProjectReportEntryModel, data.projectReportEntries));
                this.SetCumulativeProjectReport(plainToClass(CumulativeProjectReportEntryModel, data.cumulativeProjectReportEntries));
                this.SetProjectReportProjectDisplayString(data.projectDisplayString);
                this.SetProjectReportTotalTime(data.totalTime);
                return data;
            }
        }
        // Excel Export
        async GetProjectReportAsExcel(projectReport) {
            var url = `${getTenantId()}/${this.apiNode}/Excel/projectreport`;
            let { data } = await service.post(url, projectReport, { responseType: "blob" });
            return data;
        }
        async SetProjectsForProjectReport(validProjectReportProjects) {
            this.validProjectReportProjects = validProjectReportProjects;
        }
        async SetProjectReportMembers(projectReportMembers) {
            this.projectReportMembers = projectReportMembers;
        }
        async SetProjectReport(projectReportEntries) {
            this.projectReportEntries = projectReportEntries;
        }
        async SetCumulativeProjectReport(cumulativeProjectReportEntries) {
            this.cumulativeProjectReportEntries = cumulativeProjectReportEntries;
        }
        async SetProjectReportProjectDisplayString(projectReportProjectDisplayString) {
            this.projectReportProjectDisplayString = projectReportProjectDisplayString;
        }
        async SetProjectReportTotalTime(totalTime) {
            this.projectReportTotalTime = totalTime;
        }
        ClearProjectReportData() {
            this.projectReportMembers = [];
        }
        async AddEntryUnderTask(payload) {
            var url = `${getTenantId()}/${this.apiNode}/add-entry-under-task?taskId=${payload.taskId}&taskName=${payload.taskName}`;
            let { data } = await service.get(url);
            if (data) {
                this.AppendCwMiniEntry(data.clockWorkEntries);
            }
            return data;
        }
        AppendCwMiniEntry(payLoadEntries) {
            var updateEntries = payLoadEntries.filter((x) => x.endTime === null);
            this.cwMiniEntry = updateEntries[0];
        }
        async SearchInClockWorkDetails(payLoad) {
            var url = `${getTenantId()}/${this.apiNode}/search?searchCharacters=${payLoad.searchCharacters}&skip=${payLoad.skip}`;
            let { data } = await service.post(url);
            if (data) {
                this.SetFilteredEntries(plainToClass(ClockWorkEntryModel, data.clockWorkEntries));
                this.GetCount(data.totalCount);
                return data;
            }
        }
        async GettingMostRecentEntries(skipCount) {
            var url = `${getTenantId()}/${this.apiNode}/most-recent-entries/` + skipCount;
            let { data } = await service.get(url);
            if (data) {
                this.SetFilteredEntries(plainToClass(ClockWorkEntryModel, data.clockWorkEntries));
                this.GetCount(data.totalCount);
                return data;
            }
        }
        async GetCount(Count) {
            this.totalCount = Count;
        }
        async SetFilteredEntries(clockWorkEntries) {
            const uniqueEntries = [...new Set([...this.filteredEntries, ...clockWorkEntries])];
            this.filteredEntries = uniqueEntries;
        }
        async ClearFilterEntries() {
            this.filteredEntries = [];
            return [];
        }
        async clearTotalCount() {
            this.totalCount = 0;
            return [];
        }
        async SetProjectsInGivenTimePeriod(validProject) {
            this.validProject = validProject;
        }
        async SetUserTimeReport(timeReportClockWorkEntries) {
            this.timeReportClockWorkEntries = timeReportClockWorkEntries;
        }
        async SetClockEntries(clockWorkEntries) {
            this.entries = clockWorkEntries;
        }
        async clearNullEntryForMNCO() {
            await this.clearNullEntry();
        }
        clearNullEntry() {
            this.clockWorkNullEntries = [];
        }
        async ResetLiveTimer() {
            this.liveTime = 0;
        }
        SetEntries(entries) {
            this.entries = entries;
            checkGaps(this.entries);
        }
        SetDefaultProject(entries) {
            this.defaultProjectAndTask = entries;
        }
        SetClockWorkWeekly(isClockWorkSetWeeklyMail) {
            this.isClockWorkSetWeeklyMail = isClockWorkSetWeeklyMail;
        }
        SetIsWFO(isWFO) {
            this.isWFO = isWFO;
        }
        SetClockWorkRunningEntries(clockWorkNullEntries) {
            if (clockWorkNullEntries.length > 0) {
                clockWorkNullEntries.forEach((x) => {
                    const parsedDate = new Date(x.timeDuration);
                    if (isToday(parsedDate)) {
                        x.timeDurationDisplay = formatDistanceToNow(parsedDate, { addSuffix: true, includeSeconds: true });
                    }
                    else if (isYesterday(parsedDate)) {
                        x.timeDurationDisplay = "Yesterday";
                    }
                    else {
                        x.timeDurationDisplay = formatDistanceToNow(parsedDate, { addSuffix: true });
                    }
                });
            }
            this.clockWorkNullEntries = clockWorkNullEntries;
        }
        RemoveEntries(entries) {
            var that = this;
            entries.forEach((entry) => {
                const index = that.entries
                    .map(function (array) {
                    return array.id;
                })
                    .indexOf(entry, 0);
                if (index > -1) {
                    that.entries.splice(index, 1);
                }
            });
            that.entries = [...that.entries];
            //that.clockWorkNullEntries.length = 0;
            checkGaps(that.entries);
        }
        AppendEntries(payLoadEntries) {
            var that = this;
            payLoadEntries.forEach((pEntry) => {
                var target = that.entries.findIndex((x) => x.id == pEntry.id);
                if (target !== -1) {
                    var existingEntry = that.entries.find((x) => x.id == pEntry.id);
                    pEntry.description = existingEntry.description == "" ? "Untitled Entry" : existingEntry.description;
                    that.entries[target] = pEntry;
                }
                else {
                    that.entries.push(pEntry);
                }
            });
            checkGaps(that.entries);
            that.entries = [...that.entries];
        }
        touchEntries() {
            var that = this;
            that.entries = [...that.entries];
        }
        // CW Mini Module
        async GetClockWorkMini(entryDate) {
            var url = `${getTenantId()}/${this.apiNode}/clockWorkMini/${entryDate}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetCWMini(data);
                //this.SetCWMiniLoaded(true);
                return data;
            }
        }
        async AddCwMiniEntry(clockWorkEntry) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let operation = new ClockWorkEntryOperation();
            operation.type = "add";
            operation.entryPayLoad = clockWorkEntry;
            let { data } = await service.post(url, operation);
            if (data) {
                this.ReplaceCWMiniEntry(plainToClass(ClockWorkEntryModel, data.clockWorkEntries));
            }
            return data;
        }
        async EndCwMiniEntry(activeEntry) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let operation = new ClockWorkEntryOperation();
            operation.type = "end";
            operation.entryPayLoad = activeEntry;
            let { data } = await service.post(url, operation);
            return data;
        }
        async UpdateCwMiniEntry(activeEntry) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let operation = new ClockWorkEntryOperation();
            operation.type = "update";
            operation.entryPayLoad = activeEntry;
            if (operation.entryPayLoad) {
                let { data } = await service.post(url, operation);
                return data;
            }
        }
        SetCWMini(cwMini) {
            this.longRunningEntry = cwMini.longRunningEntry;
            this.cwMiniEntry = cwMini.clockWorkMini;
        }
        // @Mutation
        // public SetCWMiniLoaded(value: boolean) {
        // 	this.cwMiniLoaded = value;
        // }
        ReplaceCWMiniEntry(payLoadEntries) {
            var updateEntries = payLoadEntries.filter((x) => x.endTime === null);
            this.cwMiniEntry = updateEntries[0];
        }
        async GetClockWorkProjectSummaries(entryDate) {
            var url = `${getTenantId()}/${this.apiNode}/clockwork-project-summaries/${entryDate}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetDayProjectSummaries(plainToClass(ClockWorkProjectSummaryModel, data.clockWorkDayProjectsSummaries));
                this.SetWeekProjectSummaries(plainToClass(ClockWorkProjectSummaryModel, data.clockWorkWeekProjectsSummaries));
                this.SetWeekEntries(plainToClass(ClockWorkEntryModel, data.clockWorkWeeklyEntries));
                return data;
            }
        }
        SetWeekEntries(clockWorkWeeklyEntries) {
            this.weekEntries = clockWorkWeeklyEntries;
        }
        SetDayProjectSummaries(projectDaySummaries) {
            this.projectDaySummaries = projectDaySummaries;
        }
        SetWeekProjectSummaries(projectWeekSummaries) {
            this.projectWeekSummaries = projectWeekSummaries;
        }
        ClearData() {
            this.validProject = [];
        }
        async AdjustRunningEntry(payload) {
            var url = `${getTenantId()}/${this.apiNode}/adjust?entryId=${payload.entryId}&newStartTime=${payload.newStartTime}&newEndTime=${payload.newEndTime}&isMnco=${payload.isMnco}`;
            let { data } = await service.post(url);
            if (data) {
                this.RemoveRunningEntry(payload.entryId);
                return data;
            }
        }
        async DeleteRunningEntry(entryId) {
            var url = `${getTenantId()}/${this.apiNode}/entries`;
            let { data } = await service.post(url, [entryId]);
            if (data) {
                this.RemoveRunningEntry(entryId);
                return data;
            }
        }
        RemoveRunningEntry(entryId) {
            var index = this.clockWorkNullEntries.findIndex((x) => x.clockWorkEntry.id == entryId);
            if (index > -1) {
                this.clockWorkNullEntries.splice(index, 1);
            }
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof String !== "undefined" && String) === "function" ? _a : Object]),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], ClockWorksModule.prototype, "GetEntries", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], ClockWorksModule.prototype, "GetClockWorkRunningEntries", null);
    __decorate([
        Action({ rawError: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof ClockWorkEntryModel !== "undefined" && ClockWorkEntryModel) === "function" ? _d : Object]),
        __metadata("design:returntype", typeof (_e = typeof Promise !== "undefined" && Promise) === "function" ? _e : Object)
    ], ClockWorksModule.prototype, "AddEntry", null);
    __decorate([
        Action({ rawError: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_f = typeof ClockWorkEntryModel !== "undefined" && ClockWorkEntryModel) === "function" ? _f : Object]),
        __metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
    ], ClockWorksModule.prototype, "RestartEntry", null);
    __decorate([
        Action({ rawError: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_h = typeof ClockWorkEntryModel !== "undefined" && ClockWorkEntryModel) === "function" ? _h : Object]),
        __metadata("design:returntype", typeof (_j = typeof Promise !== "undefined" && Promise) === "function" ? _j : Object)
    ], ClockWorksModule.prototype, "CrossoverEntry", null);
    __decorate([
        Action({ rawError: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_k = typeof ClockWorkEntryModel !== "undefined" && ClockWorkEntryModel) === "function" ? _k : Object]),
        __metadata("design:returntype", typeof (_l = typeof Promise !== "undefined" && Promise) === "function" ? _l : Object)
    ], ClockWorksModule.prototype, "UpdateEntry", null);
    __decorate([
        Action({ rawError: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_m = typeof ClockWorkEntryModel !== "undefined" && ClockWorkEntryModel) === "function" ? _m : Object]),
        __metadata("design:returntype", typeof (_o = typeof Promise !== "undefined" && Promise) === "function" ? _o : Object)
    ], ClockWorksModule.prototype, "EndEntry", null);
    __decorate([
        Action({ rawError: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_p = typeof ClockWorkEntryModel !== "undefined" && ClockWorkEntryModel) === "function" ? _p : Object]),
        __metadata("design:returntype", typeof (_q = typeof Promise !== "undefined" && Promise) === "function" ? _q : Object)
    ], ClockWorksModule.prototype, "BreakEntry", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", typeof (_r = typeof Promise !== "undefined" && Promise) === "function" ? _r : Object)
    ], ClockWorksModule.prototype, "DeleteEntries", null);
    __decorate([
        Action({ rawError: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_s = typeof Promise !== "undefined" && Promise) === "function" ? _s : Object)
    ], ClockWorksModule.prototype, "AssignEntries", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ClockWorksModule.prototype, "SetAssignEntries", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_t = typeof Promise !== "undefined" && Promise) === "function" ? _t : Object)
    ], ClockWorksModule.prototype, "AdjustEntry", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_u = typeof Promise !== "undefined" && Promise) === "function" ? _u : Object)
    ], ClockWorksModule.prototype, "AdjustMultipleEntries", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_v = typeof Promise !== "undefined" && Promise) === "function" ? _v : Object)
    ], ClockWorksModule.prototype, "SplitEntry", null);
    __decorate([
        Action({ rawError: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_w = typeof ClockWorkEntryModel !== "undefined" && ClockWorkEntryModel) === "function" ? _w : Object]),
        __metadata("design:returntype", typeof (_x = typeof Promise !== "undefined" && Promise) === "function" ? _x : Object)
    ], ClockWorksModule.prototype, "UpFill", null);
    __decorate([
        Action({ rawError: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_y = typeof ClockWorkEntryModel !== "undefined" && ClockWorkEntryModel) === "function" ? _y : Object]),
        __metadata("design:returntype", typeof (_z = typeof Promise !== "undefined" && Promise) === "function" ? _z : Object)
    ], ClockWorksModule.prototype, "DownFill", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_0 = typeof Promise !== "undefined" && Promise) === "function" ? _0 : Object)
    ], ClockWorksModule.prototype, "UpdateWorkStatus", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_1 = typeof ITimeReportDTO !== "undefined" && ITimeReportDTO) === "function" ? _1 : Object]),
        __metadata("design:returntype", typeof (_2 = typeof Promise !== "undefined" && Promise) === "function" ? _2 : Object)
    ], ClockWorksModule.prototype, "GetProjectsInGivenTimePeriod", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_3 = typeof ITimeReportDTO !== "undefined" && ITimeReportDTO) === "function" ? _3 : Object]),
        __metadata("design:returntype", typeof (_4 = typeof Promise !== "undefined" && Promise) === "function" ? _4 : Object)
    ], ClockWorksModule.prototype, "GetUserTimeReport", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], ClockWorksModule.prototype, "setCumulativeTimeReport", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", Promise)
    ], ClockWorksModule.prototype, "ToalTime", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_5 = typeof ITimeReportDTO !== "undefined" && ITimeReportDTO) === "function" ? _5 : Object]),
        __metadata("design:returntype", typeof (_6 = typeof Promise !== "undefined" && Promise) === "function" ? _6 : Object)
    ], ClockWorksModule.prototype, "GetUserTimeReportAsExcel", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_7 = typeof Promise !== "undefined" && Promise) === "function" ? _7 : Object)
    ], ClockWorksModule.prototype, "GetProjectsForProjectReport", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_8 = typeof Guid !== "undefined" && Guid) === "function" ? _8 : Object]),
        __metadata("design:returntype", typeof (_9 = typeof Promise !== "undefined" && Promise) === "function" ? _9 : Object)
    ], ClockWorksModule.prototype, "GetProjectMembersForReport", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_10 = typeof IProjectReportDTO !== "undefined" && IProjectReportDTO) === "function" ? _10 : Object]),
        __metadata("design:returntype", typeof (_11 = typeof Promise !== "undefined" && Promise) === "function" ? _11 : Object)
    ], ClockWorksModule.prototype, "GetProjectReport", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_12 = typeof IProjectReportDTO !== "undefined" && IProjectReportDTO) === "function" ? _12 : Object]),
        __metadata("design:returntype", typeof (_13 = typeof Promise !== "undefined" && Promise) === "function" ? _13 : Object)
    ], ClockWorksModule.prototype, "GetProjectReportAsExcel", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], ClockWorksModule.prototype, "SetProjectsForProjectReport", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], ClockWorksModule.prototype, "SetProjectReportMembers", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], ClockWorksModule.prototype, "SetProjectReport", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], ClockWorksModule.prototype, "SetCumulativeProjectReport", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], ClockWorksModule.prototype, "SetProjectReportProjectDisplayString", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", Promise)
    ], ClockWorksModule.prototype, "SetProjectReportTotalTime", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ClockWorksModule.prototype, "ClearProjectReportData", null);
    __decorate([
        Action({ rawError: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_14 = typeof Promise !== "undefined" && Promise) === "function" ? _14 : Object)
    ], ClockWorksModule.prototype, "AddEntryUnderTask", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ClockWorksModule.prototype, "AppendCwMiniEntry", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_15 = typeof Promise !== "undefined" && Promise) === "function" ? _15 : Object)
    ], ClockWorksModule.prototype, "SearchInClockWorkDetails", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", typeof (_16 = typeof Promise !== "undefined" && Promise) === "function" ? _16 : Object)
    ], ClockWorksModule.prototype, "GettingMostRecentEntries", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", Promise)
    ], ClockWorksModule.prototype, "GetCount", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], ClockWorksModule.prototype, "SetFilteredEntries", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], ClockWorksModule.prototype, "ClearFilterEntries", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], ClockWorksModule.prototype, "clearTotalCount", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], ClockWorksModule.prototype, "SetProjectsInGivenTimePeriod", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], ClockWorksModule.prototype, "SetUserTimeReport", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], ClockWorksModule.prototype, "SetClockEntries", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], ClockWorksModule.prototype, "clearNullEntryForMNCO", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ClockWorksModule.prototype, "clearNullEntry", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], ClockWorksModule.prototype, "ResetLiveTimer", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ClockWorksModule.prototype, "SetEntries", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_17 = typeof ProjectTaskComboModel !== "undefined" && ProjectTaskComboModel) === "function" ? _17 : Object]),
        __metadata("design:returntype", void 0)
    ], ClockWorksModule.prototype, "SetDefaultProject", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], ClockWorksModule.prototype, "SetClockWorkWeekly", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], ClockWorksModule.prototype, "SetIsWFO", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ClockWorksModule.prototype, "SetClockWorkRunningEntries", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ClockWorksModule.prototype, "RemoveEntries", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ClockWorksModule.prototype, "AppendEntries", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ClockWorksModule.prototype, "touchEntries", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_18 = typeof String !== "undefined" && String) === "function" ? _18 : Object]),
        __metadata("design:returntype", typeof (_19 = typeof Promise !== "undefined" && Promise) === "function" ? _19 : Object)
    ], ClockWorksModule.prototype, "GetClockWorkMini", null);
    __decorate([
        Action({ rawError: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_20 = typeof ClockWorkEntryModel !== "undefined" && ClockWorkEntryModel) === "function" ? _20 : Object]),
        __metadata("design:returntype", typeof (_21 = typeof Promise !== "undefined" && Promise) === "function" ? _21 : Object)
    ], ClockWorksModule.prototype, "AddCwMiniEntry", null);
    __decorate([
        Action({ rawError: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_22 = typeof ClockWorkEntryModel !== "undefined" && ClockWorkEntryModel) === "function" ? _22 : Object]),
        __metadata("design:returntype", typeof (_23 = typeof Promise !== "undefined" && Promise) === "function" ? _23 : Object)
    ], ClockWorksModule.prototype, "EndCwMiniEntry", null);
    __decorate([
        Action({ rawError: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_24 = typeof ClockWorkEntryModel !== "undefined" && ClockWorkEntryModel) === "function" ? _24 : Object]),
        __metadata("design:returntype", typeof (_25 = typeof Promise !== "undefined" && Promise) === "function" ? _25 : Object)
    ], ClockWorksModule.prototype, "UpdateCwMiniEntry", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_26 = typeof IClockWorkMiniResponse !== "undefined" && IClockWorkMiniResponse) === "function" ? _26 : Object]),
        __metadata("design:returntype", void 0)
    ], ClockWorksModule.prototype, "SetCWMini", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ClockWorksModule.prototype, "ReplaceCWMiniEntry", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_27 = typeof String !== "undefined" && String) === "function" ? _27 : Object]),
        __metadata("design:returntype", typeof (_28 = typeof Promise !== "undefined" && Promise) === "function" ? _28 : Object)
    ], ClockWorksModule.prototype, "GetClockWorkProjectSummaries", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ClockWorksModule.prototype, "SetWeekEntries", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ClockWorksModule.prototype, "SetDayProjectSummaries", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ClockWorksModule.prototype, "SetWeekProjectSummaries", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ClockWorksModule.prototype, "ClearData", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_29 = typeof Promise !== "undefined" && Promise) === "function" ? _29 : Object)
    ], ClockWorksModule.prototype, "AdjustRunningEntry", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_30 = typeof Promise !== "undefined" && Promise) === "function" ? _30 : Object)
    ], ClockWorksModule.prototype, "DeleteRunningEntry", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ClockWorksModule.prototype, "RemoveRunningEntry", null);
    ClockWorksModule = __decorate([
        Module({ dynamic: true, store: store, name: "clockWorks", namespaced: true })
    ], ClockWorksModule);
    return ClockWorksModule;
})();
export const ClockWorkModule = getModule(ClockWorksModule);
